import React, { useId, useState } from "react";
import { DatasetBarChartProps, IDataSet } from "components/dashboard/charts/interfaces";
import ChartWrapper from "components/dashboard/charts/chart-wrapper/ChartWrapper";
import DatasetBarChart from "components/dashboard/charts/bar-chart/DatasetBarChart";
import { APIResponseToDatasetDataInfoResponseArray } from "components/dashboard/charts/bar-chart/DatasetBarChartDataConverter";
import Plotly, { ModeBarButton, ModeBarDefaultButtons } from "plotly.js";
import { APIResponse } from "services/HttpService";
import { clipboardIcon, questionMarkIcon } from "../icons";
import copyChartToClipBoard from "../chartUtils";
import DatasetsTitlesShower from "../DatasetsTitlesShower";


const DatasetBarChartRenderer = (props: DatasetBarChartProps) => {
  const [titlesDialog, setTitlesDialog] = useState(false);
  const uniqueId = useId();

  const overriddenTitles = (props.datasets || []).filter(dataset => dataset.overriddenTitle);

  const titlesAndOverriddenTitles =
    overriddenTitles.length > 0
      ? (props.datasets || []).map(dataset => ({
          title: dataset.identifier,
          overriddenTitle: dataset.overriddenTitle!,
        }))
      : [];

  const chartConfig: Partial<Plotly.Config> = {
    displaylogo: false,
    modeBarButtonsToRemove: ["lasso2d", "select2d"],
    modeBarButtonsToAdd: [
      {
        title: "Copy chart to Clipboard",
        name: "Copy chart to Clipboard",
        icon: clipboardIcon,
        click: copyChartToClipBoard,
      },
      overriddenTitles.length > 0
        ? {
            title: "Show Titles",
            name: "Show Titles",
            icon: questionMarkIcon,
            click: () => setTitlesDialog(true),
          }
        : null,
    ].filter(Boolean) as ModeBarDefaultButtons[] | ModeBarButton[] | undefined,
  };

  const identifiers = props.datasets?.map(dataset => dataset.identifier);

  const promiseHandler = (res: APIResponse<IDataSet>) =>
    APIResponseToDatasetDataInfoResponseArray(res, props.datasets || []);

  return (
    <ChartWrapper
      uniqueKey={uniqueId}
      identifiers={identifiers || props.identifiers}
      showDateSelection
      promiseHandler={promiseHandler}
      updateFrequency={props.updateFrequency}
      loadConf={props.loadConf}
      hideRefresh={props.hideRefresh}
      dynamicHeight={props.dynamicHeight}
      referenceTime={props.referenceTime}
      datasetChart="bar"
      chartConfig={chartConfig}
      width={props.width}
      reportMode={props.reportMode}
    >
      {(wrapper: any) => (
        <div>
          {titlesDialog && (
            <DatasetsTitlesShower
              dialog={titlesDialog}
              setDialog={setTitlesDialog}
              titlesAndOverriddenTitles={titlesAndOverriddenTitles}
            />
          )}
          <DatasetBarChart
            data={wrapper.data}
            width={wrapper.width}
            height={wrapper.height}
            dateFormat={props.dateFormat}
            chartConfig={wrapper.chartConfig}
          />
        </div>
      )}
    </ChartWrapper>
  );
};

export default DatasetBarChartRenderer;
